<template>
    <div>
      <apexchart
        type="radialBar"
        :height="chartHeight"
        :series="[value]"
        :options="chartOptions"
      />
    </div>
  </template>
  
  <script>
  import VueApexCharts from 'vue-apexcharts';
  
  export default {
    name: 'SemiCircleGauge',
    components: {
      apexchart: VueApexCharts,
    },
    props: {
      value: {
        type: Number,
        required: true,
      },
      readableLabel: {
        type: String,
        default: null,
      }
    },
    computed: {
      chartHeight() {
        return window.innerWidth >= 768 ? 250 : 150;
      },
      displayValue() {
        return this.readableLabel ?? this.value.toString() ;
      },
      chartOptions() {
        return {
          chart: {
            type: 'radialBar',
            sparkline: {
              enabled: true,
            },
          },
          plotOptions: {
            radialBar: {
              startAngle: -90,
              endAngle: 90,
              hollow: {
                size: '65%',
              },
              track: {
                background: '#e7e7e7',
                strokeWidth: '97%',
                margin: 5, 
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  fontSize: '22px',
                  offsetY: 40, 
                  formatter: () => this.displayValue
                },
              },
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              gradientToColors: [this.endColor], 
              inverseColors: false,
              stops: [0, 100],
              opacityFrom: 1,
              opacityTo: 1,
            },
          },
          colors: [this.startColor],
          labels: ['Progress'],
        };
      },
  
      startColor() {
        return '#2ecc71';
      },
  
      endColor() {
        const val = this.value;
        if (val <= 40) return '#2ecc71';       
        if (val <= 70) return '#4f81bd';       
        return '#f46a6a';                  
      },
    },
  };
  </script>
  